import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { H2 } from 'foundations-components/transitional/components/H2';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useId } from 'react';
import { AvailableUseCases, FEATURE_LIST, UseCases } from './useCaseConstants';
import { useUseCaseContext } from './UseCaseContext';
import UseCaseOption from './UseCaseOption';
import { MarketingUseCase } from './icons/MarketingUseCase';
import { SalesUseCase } from './icons/SalesUseCase';
import { ServiceUseCase } from './icons/ServiceUseCase';
import { SmartCrmUseCase } from './icons/SmartCrmUseCase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const USE_CASE_CONFIG = {
  [UseCases.MARKETING]: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.marketing.tabTitle"
    }),
    Icon: /*#__PURE__*/_jsx(MarketingUseCase, {})
  },
  [UseCases.SALES]: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.sales.tabTitle"
    }),
    Icon: /*#__PURE__*/_jsx(SalesUseCase, {})
  },
  [UseCases.SERVICE]: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.service.tabTitle"
    }),
    Icon: /*#__PURE__*/_jsx(ServiceUseCase, {})
  },
  [UseCases.SMART_CRM]: {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.pagesV2.smart-crm.tabTitle"
    }),
    Icon: /*#__PURE__*/_jsx(SmartCrmUseCase, {})
  }
};
const UseCasePositioning = () => {
  const {
    selectedUseCases,
    toggleUseCase
  } = useUseCaseContext();
  const useCaseGroupId = useId();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "500",
    justifyContent: "center",
    alignItems: "center",
    paddingBlock: "1200",
    backgroundColor: "fill-accent-orange-subtle-alt",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H2, {
        textAlign: "center",
        typography: "body-300",
        margin: "50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.hsoc.useCases.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        textAlign: "center",
        id: useCaseGroupId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.hsoc.useCases.subtitle"
        })
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      gap: "400",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      role: "group",
      "aria-labelledby": useCaseGroupId,
      children: AvailableUseCases.map(useCase => {
        const {
          label,
          Icon
        } = USE_CASE_CONFIG[useCase];
        return /*#__PURE__*/_jsx(UseCaseOption, {
          useCase: useCase,
          selected: selectedUseCases.includes(useCase),
          onToggle: toggleUseCase,
          Label: label,
          Icon: Icon
        }, useCase);
      })
    }), /*#__PURE__*/_jsx(List, {
      use: "inline-divided",
      justifyContent: "center",
      children: FEATURE_LIST.map(feature => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          display: "inline-block",
          children: feature
        })
      }, feature))
    })]
  });
};
export default UseCasePositioning;